import { createAppQueryBuilder } from '@autone/utils';
import { createApi } from '@reduxjs/toolkit/query/react';

import { customBaseQuery } from '../utils/custom-base-query';

import {
  getBatchDataFreshness,
  type GetBatchDataFreshnessRequest,
  type GetBatchDataFreshnessResponse,
  getGlobalDataFreshness,
  type GetGlobalDataFreshnessRequest,
  type GetGlobalDataFreshnessResponse,
} from './transformers';
import { type GetDataIngestionSourcesResponse } from './types';

const API_PREFIX = '/data-ingestion';

const dataIngestionQueryBuilder = createAppQueryBuilder<
  'data-ingestion',
  typeof API_PREFIX
>();

/**
 * @description data-ingestion redux api to be used by other apps and packages
 * supplies data freshness status for the global data and batch data
 */
export const dataIngestionApi = createApi({
  reducerPath: 'dataIngestionApi',
  baseQuery: async (args, api, extraOptions) =>
    customBaseQuery(args, api, extraOptions, `v2${API_PREFIX}`),
  endpoints: (builder) => ({
    getGlobalDataFreshness: builder.query<
      GetGlobalDataFreshnessResponse,
      GetGlobalDataFreshnessRequest
    >({
      query: dataIngestionQueryBuilder('get', '/sources'),
      transformResponse: (response: GetDataIngestionSourcesResponse) =>
        getGlobalDataFreshness(response),
    }),
    getBatchDataFreshness: builder.query<
      GetBatchDataFreshnessResponse,
      GetBatchDataFreshnessRequest
    >({
      query: dataIngestionQueryBuilder('get', '/sources'),
      transformResponse: (
        response: GetDataIngestionSourcesResponse,
        _,
        { query: { module_id, batch_created_at } },
      ) => getBatchDataFreshness(response, module_id, batch_created_at),
    }),
  }),
});

export const { useGetGlobalDataFreshnessQuery, useGetBatchDataFreshnessQuery } =
  dataIngestionApi;
